module.exports = __webpack_public_path__ + "gamecode/img/ztmslgtw_favicon.png?ccb8351c";